import React, { useState } from "react";
import { useTypewriter } from "../hooks/useTypewriter";
import { motion, AnimatePresence } from "framer-motion";
import ScrollReveal from "./ScrollReveal";
import { useLanguage } from "../context/LanguageContext";
import { translations } from "../i18n";

import jsImage from "../assets/imgs/JS.svg";
import nodeImage from "../assets/imgs/NODE.svg";
import dockerImage from "../assets/imgs/DOCKER.svg";
import mongoImage from "../assets/imgs/MONGO.svg";
import pythonImage from "../assets/imgs/PYTHON.svg";
import laravelImage from "../assets/imgs/LARAVEL.svg";
import rImage from "../assets/imgs/R.svg";
import hadoopImage from "../assets/imgs/HADOOP.svg";
import cssImage from "../assets/imgs/CSS.svg";
import javaImage from "../assets/imgs/JAVA.svg";
import reactImage from "../assets/imgs/REACT.svg";
import gitImage from "../assets/imgs/GIT.svg";

const icons = [
  { id: "mongo", src: mongoImage },
  { id: "node", src: nodeImage },
  { id: "hadoop", src: hadoopImage },
  { id: "js", src: jsImage },
  { id: "python", src: pythonImage },
  { id: "docker", src: dockerImage },
  { id: "css", src: cssImage },
  { id: "react", src: reactImage },
  { id: "r", src: rImage },
  { id: "java", src: javaImage },
  { id: "laravel", src: laravelImage },
  { id: "git", src: gitImage },
];

function Knowledge() {
  const [activeIndex, setActiveIndex] = useState(null);
  const { language } = useLanguage();

  const fullText =
  activeIndex !== null
    ? translations[language].skills[icons[activeIndex].id]
    : translations[language].skills.initialMessage;

  const displayedText = useTypewriter(fullText, 20);

  return (
    <div className="knowledge-container" id="knowledge-container">
      <div className="section-title">
        {">  " + translations[language].sectionTitles.knowledge}
      </div>
      <ScrollReveal delay={0.5}>
        <div className="knowledge-table-container">
          <div className="knowledge-grid">
            {icons.map((icon, index) => (
              <div
                key={index}
                className={`grid-item ${
                  activeIndex === index ? "grid-focus" : ""
                }`}
                onClick={() => setActiveIndex(index)}
                style={{
                  "--focus-color": "rgba(0, 255, 224, 0.8)",
                }}
              >
                <img
                  src={icon.src}
                  alt="Icon"
                  draggable="false"
                  onDragStart={(e) => e.preventDefault()}
                />
              </div>
            ))}
          </div>
          <div className="knowledge-text-container">
            <AnimatePresence mode="wait">
              {displayedText && (
                <motion.div
                  key={fullText}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.3, ease: "easeInOut" }}
                  className="knowledge-text"
                >
                  {displayedText}
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </div>
      </ScrollReveal>
    </div>
  );
}

export default Knowledge;
